import axiosInstance from "./AxiosTokenInstance";
import store from "../store";
import { SET_LOADER_VISIBILITY } from "../helpers/vuex-constants";

export default {
  showErrorMessage(url, error) {
    store.dispatch(SET_LOADER_VISIBILITY, false);
    if (error.response.status == 401 || error.response.status == 403) {
      this.setNotificationMessage(
        "error",
        `You have been logged out. Please login again.`
      );
    } else {
      this.setNotificationMessage(
        "error",
        `Oops. Something went wrong. Please try again later.`
      );
    }

    throw new Error(url);
  },
  setNotificationMessage(variation, message) {
    store.dispatch("setNotificationSummary", {
      isShow: true,
      variation: variation,
      text: message,
    });
  },

  async get(url) {
    return axiosInstance.get(url).catch((error) => {
      this.showErrorMessage(url, error);
    });
  },

  async post(url, data, options) {
    return axiosInstance.post(url, data, options).catch((error) => {
      this.showErrorMessage(url, error);
    });
  },

  async put(url, data) {
    return axiosInstance.put(url, data).catch((error) => {
      this.showErrorMessage(url, error);
    });
  },
  async delete(url) {
    return axiosInstance.delete(url).catch((error) => {
      this.showErrorMessage(url, error);
    });
  },
};
